"use strict";

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tag = void 0;

var Color_1 = require("../Core/Colors/Color");

var HSLColor_1 = require("./Colors/HSLColor");

var LABColor_1 = require("./Colors/LABColor");
/**
 * Represents meta-data for a tag
 * @remarks
 * 1. To represent the color Tag class uses only the hue component
 * and generates a number of color variations based on that value.
 * 2. The `Tag` object is *immutable*, all public properties are readonly.
 */


var Tag = /*#__PURE__*/function () {
  function Tag(name, color) {
    var id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";

    _classCallCheck(this, Tag);

    this.tagColorPure = "";
    this.tagColorAccent = "";
    this.tagColorHighlight = "";
    this.tagColorShadow = "";
    this.tagColorNoColor = "";
    this.tagColorDark = "";
    this.tagName = name;

    if (typeof color === "number") {
      this.colorObj = new Color_1.Color(new HSLColor_1.HSLColor(color % 360 / 360.0, 1, 0.5));
    } else if (typeof color === "string") {
      this.colorObj = new Color_1.Color(color);
    } else if (color instanceof Color_1.Color) {
      this.colorObj = color;
    }

    this.tagID = id;
  }
  /**
   * Creates a new tag based on extracting specific properties from any provided object
   * @param data - An `ITag` object with `name`, `colorHue` and `id` properties
   * @returns A new `Tag` object
   */


  _createClass(Tag, [{
    key: "copy",

    /**
     * Creates a copy of this tag
     * @returns A new `Tag` object with copied properties
     */
    value: function copy() {
      return new Tag(this.tagName, this.colorObj, this.tagID);
    }
    /**
     * Returns a JSON representation of the tag
     * @returns An `ITag` object with `name`, `colorHue` and `id` properties
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        name: this.tagName,
        colorHue: this.colorHue,
        color: this.colorObj.sRGB.toHex(),
        id: this.tagID
      };
    }
  }, {
    key: "colorHue",

    /**
     * The hue-value of the tag's color. *Readonly*
     */
    get: function get() {
      return this.colorObj.HSL.h * 360;
    }
    /**
     * The tag's color in hex format. *Readonly*
     */

  }, {
    key: "color",
    get: function get() {
      return this.colorObj.sRGB.toHex();
    }
    /**
     * The `name` of the tag. *Readonly*
     */

  }, {
    key: "name",
    get: function get() {
      return this.tagName;
    }
    /**
     * The `id` of the tag. *Readonly*
     */

  }, {
    key: "id",
    get: function get() {
      return this.tagID;
    }
    /**
     * Returns the pure color variation of the tag's color
     * @returns String hsl(H, 100%, 50%)
     */

  }, {
    key: "colorPure",
    get: function get() {
      if (this.tagColorPure === "") {
        this.tagColorPure = this.colorObj.sRGB.toCSSString(); // OLD: `hsl(${this.tagHue.toString()}, 100%, 50%)`;
      }

      return this.tagColorPure;
    }
    /**
     * Returns the accent color variation of the tag's color.
     * Accent = almost pure, alpha = 0.8.
     * @returns Hex string for the color
     */

  }, {
    key: "colorAccent",
    get: function get() {
      if (this.tagColorAccent === "") {
        this.tagColorAccent = this.colorObj.sRGB.toCSSString(0.8); // OLD: `hsla(${this.tagHue.toString()}, 100%, 50%, 0.5)`;
      }

      return this.tagColorAccent;
    }
    /**
     * Returns the highlight color variation of the tag's color.
     * Highlight = grayed pure, alpha = 0.4
     * @returns Hex string for the color
     */

  }, {
    key: "colorHighlight",
    get: function get() {
      if (this.tagColorHighlight === "") {
        var lab = this.colorObj.LAB.toArray();
        var highlight = new LABColor_1.LABColor(lab[0] * 0.7, lab[1] * 0.7, lab[2] * 0.7);
        this.tagColorHighlight = highlight.toSRGB().truncate().toCSSString(0.4); // OLD: `hsla(${this.tagHue.toString()}, 80%, 40%, 0.3)`;
      }

      return this.tagColorHighlight;
    }
    /**
     * Returns the shadow color variation of the tag's color
     * Shadow = grayed pure, alpha = 0.2
     * @returns Hex string for the color
     */

  }, {
    key: "colorShadow",
    get: function get() {
      if (this.tagColorShadow === "") {
        var lab = this.colorObj.LAB.toArray();
        var shadow = new LABColor_1.LABColor(lab[0] * 0.6, lab[1] * 0.6, lab[2] * 0.6);
        this.tagColorShadow = shadow.toSRGB().truncate().toCSSString(0.2); // OLD: `hsla(${this.tagHue.toString()}, 50%, 30%, 0.2)`;
      }

      return this.tagColorShadow;
    }
    /**
     * Returns the dark color variation of the tag's color.
     * Dark = pure with decreased lightness and grayed.
     * @returns Hex string for the color
     */

  }, {
    key: "colorDark",
    get: function get() {
      if (this.tagColorDark === "") {
        var lab = this.colorObj.LAB.toArray();
        var dark = new LABColor_1.LABColor(lab[0] * 0.5, lab[1] * 0.5, lab[2] * 0.5);
        this.tagColorDark = dark.toSRGB().truncate().toCSSString(0.8); // OLD: `hsla(${this.tagHue.toString()}, 50%, 30%, 0.8)`;
      }

      return this.tagColorDark;
    }
    /**
     * Returns the fully transparent color variation of the tag's color
     * @returns Hex string for the color
     */

  }, {
    key: "colorNoColor",
    get: function get() {
      if (this.tagColorNoColor === "") {
        this.tagColorNoColor = "rgba(0, 0, 0, 0.0)";
      }

      return this.tagColorNoColor;
    }
  }], [{
    key: "BuildFromJSON",
    value: function BuildFromJSON(data) {
      if (data.color !== undefined) {
        return new Tag(data.name, new Color_1.Color(data.color), data.id === undefined ? "" : data.id);
      } else if (data.colorHue !== undefined) {
        return new Tag(data.name, new Color_1.Color(new HSLColor_1.HSLColor(data.colorHue % 360 / 360.0, 1, 0.5)), data.id === undefined ? "" : data.id);
      }
    }
    /**
     * Extracts the hue component from a provided CSS color string
     * @param color - A CSS-color in "#RRGGBB" or "#RGB" format
     * @returns A hue value for provided color
     * @deprecated Use the Color class instead.
     */

  }, {
    key: "getHueFromColor",
    value: function getHueFromColor(color) {
      var c = new Color_1.Color(color);
      return c.HSL.h * 360;
    }
  }]);

  return Tag;
}();

exports.Tag = Tag;